import React from "react";
import { useState, useEffect } from "react";
import "./styles.scss";
import truck from "../../../../assets/images/truck.svg";
import { Modal } from "antd";
import NormalButton from "component/common/NormalButton/NormalButton";
import CloseBtn from "assets/images/modalCloseBtn.png";
import DocumentsViewComponents from "component/common/DocumentsViewComp";
import { GetTruckReleasesQuantitybyid, GetTruckReleasesInvoicebyid } from "service/GrainManager";
import { Toast } from "service/toast";

const StockReleasedComp = ({
    open,
    onCancel,
    onOk,
    successMsg,
    successContent,
    isContractSuccess,
    releaseUpdateId,
    releaseOrderId,
}) => {
    const modalStyle = {
        width: "auto",
        maxWidth: "400px",
        margin: "auto",
    };
    const [data, setData] = useState({})
    const [invoiceData, setInvoiceData] = useState({})
    const [ViewDocument, setViewDocument] = useState(false)
    const [commodityWithdrawalForm, setCommodityWithdrawalForm] = useState({});
    const [billOfSupplyDetails, setBillOfSupplyDetails] = useState({});
    const [invoiceDocumentDetails, setInvoiceDocumentDetails] = useState({});
    const [ewayBillDocomentDetails, setEwayBillDocomentDetails] = useState({});
    // const releaseOrderId = localStorage.getItem('releaseOrderId')

    const getDocumentAggrement = async (id) => {
        try {
            const response = await GetTruckReleasesQuantitybyid(id);
            if (response.status === 200) {
                setData(response?.data?.data)
            } else {
                Toast({ type: "error", message: response.data.message });
            }
        } catch (e) {
            console.log("e :>> ", e);
        }
    };

    const getInoviceDetails = async (id) => {
        try {
            const response = await GetTruckReleasesInvoicebyid(id);
            if (response.status === 200) {
                const finalResponse = response?.data?.data;
                setInvoiceData(finalResponse)
                setCommodityWithdrawalForm(finalResponse?.commodityWithdrawalFormDetails);
                setBillOfSupplyDetails(finalResponse?.billOfSupplyDetails);
                setInvoiceDocumentDetails(finalResponse?.InvoiceDocumentDetails);
                setEwayBillDocomentDetails(finalResponse?.ewayBillDocomentDetails);

                // isFinanceTeamApproved
                // financeTeamStatus

            } else {
                Toast({ type: "error", message: response.data.message });
            }
        } catch (e) {
            console.log("e :>> ", e);
        }
    };

    useEffect(() => {
        if (open) {
            // reset state before calling API
            setData({});
            setInvoiceData({});

            getDocumentAggrement(releaseOrderId);
            getInoviceDetails(releaseUpdateId);
        }
    }, [open, releaseOrderId, releaseUpdateId]);


    return (
        <Modal
            title={null}
            open={open}
            onOk={onOk}
            // onCancel={onCancel}
            closable={false}
            style={modalStyle}
            footer={null}
            centered
        >
            {ViewDocument ? (
                <>
                    <div className="contract-success-details">
                        <div className="text-center p-3">
                            <h5 className="fw-bold fs-5">View Invoice</h5>
                            <div>
                                <img onClick={() => { onCancel(); setViewDocument(false) }} className="closeBtn" src={CloseBtn} />
                            </div>
                        </div>
                        {commodityWithdrawalForm?.filePath && (
                            <div className="px-3 py-4">
                                <DocumentsViewComponents
                                    download
                                    pdf={commodityWithdrawalForm.filePath}
                                    fileName="Commodity Withdrawal Form.pdf"
                                    isDocument
                                />
                            </div>
                        )}
                        {billOfSupplyDetails?.filePath && (
                            <div className="px-3 py-2">
                                <DocumentsViewComponents
                                    download
                                    pdf={billOfSupplyDetails.filePath}
                                    fileName="Bill Of Supply.pdf"
                                    isDocument
                                />
                            </div>
                        )}
                        {invoiceDocumentDetails?.filePath && (
                            <div className="px-3 py-2">
                                <DocumentsViewComponents
                                    download
                                    pdf={invoiceDocumentDetails.filePath}
                                    fileName="E-Invoice.pdf"
                                    isDocument
                                />
                            </div>
                        )}
                        {ewayBillDocomentDetails?.filePath && (
                            <div className="px-3 py-2">
                                <DocumentsViewComponents
                                    download
                                    pdf={ewayBillDocomentDetails.filePath}
                                    fileName="E-way Bill.pdf"
                                    isDocument
                                />
                            </div>
                        )}
                        <div className="text-center p-2 mt-4">
                            <NormalButton
                                label="Go Back"
                                className="cancelBtn"
                                onClick={() => { setViewDocument(false) }}
                            />
                        </div>
                    </div>


                </>
            ) :
                (<>
                    <div>
                        <img onClick={onCancel} className="closeBtn" src={CloseBtn} />
                    </div>
                    <div className="contract-success-details">
                        <div className="text-center p-3">
                            <img src={truck} alt="" width={200} height={200} />
                        </div>
                        <div className="text-center p-3 pt-0">
                            <h5 className="fw-bold fs-5 text-success">Stock Released Successfully!</h5>
                            <p className="mt-2 fs-6 fw-medium">
                                Commodity has been released successfully from the{" "}
                                <strong>
                                    {data?.releaseRequestDetails?.warehouseDetails?.warehouseName || ""}
                                </strong>{" "}
                                Warehouse.
                            </p>
                        </div>

                    </div>
                    <div className="text-center p-3">
                        <div className="border rounded p-3 mt-3 bg-success-subtle border-success" style={{ borderColor: "lightgreen" }}>
                            <div className="d-flex justify-content-between">
                                <span className="text-success fw-semibold">Quantity released</span>
                                <span className="text-success fw-semibold">{data?.deliveredQuantity || 0}</span>
                            </div>
                            <div className="d-flex justify-content-between mt-2">
                                <span className="text-success fw-semibold">Available Quantity</span>
                                <span className="text-success fw-semibold">{data?.pendingQuantity || 0}</span>
                            </div>
                        </div>
                    </div>

                    <div className="text-center p-2 mt-4">
                        <NormalButton
                            disabled={!(invoiceData?.isFinanceTeamApproved && invoiceData?.financeTeamStatus === "APPROVED")}
                            label="View Invoice"
                            className="cancelBtn"
                            onClick={() => setViewDocument(true)}
                        />
                    </div>
                </>
                )}
        </Modal >
    );
};

export default StockReleasedComp;

